/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_cat_obese = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obese`)
};

const es_bmi_cat_obese = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obeso`)
};

const de_bmi_cat_obese = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adipositas`)
};

const nl_bmi_cat_obese = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obees`)
};

const fr_bmi_cat_obese = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obèse`)
};

const it_bmi_cat_obese = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obeso`)
};

const pt_br2_bmi_cat_obese = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obeso`)
};

const pt_bmi_cat_obese = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obeso`)
};

const ja_bmi_cat_obese = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`肥満`)
};

const zh_bmi_cat_obese = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`肥胖`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_cat_obese = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_cat_obese(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_cat_obese", locale)
	if (locale === "en") return en_bmi_cat_obese(inputs)
	if (locale === "es") return es_bmi_cat_obese(inputs)
	if (locale === "de") return de_bmi_cat_obese(inputs)
	if (locale === "nl") return nl_bmi_cat_obese(inputs)
	if (locale === "fr") return fr_bmi_cat_obese(inputs)
	if (locale === "it") return it_bmi_cat_obese(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_cat_obese(inputs)
	if (locale === "pt") return pt_bmi_cat_obese(inputs)
	if (locale === "ja") return ja_bmi_cat_obese(inputs)
	return zh_bmi_cat_obese(inputs)
};